import React, { Fragment } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import logo from "../../../src/assets/logo-inner.png";
import { logout } from "../../action/auth";
import { getAllDevice } from "../../action/report";
import customConfig from "../../config";
import UserProfileMenu from "./UserProfileMenu";
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

const Nav = ({
  auth: { isAuthenticated, loading },
  logout,
  getAllDevice,
  tenantLogoUrl,
}) => {
  const logout_click = () => {
    logout(CLIENT_ID);
    getAllDevice("");
  };

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  }
  return (
    <Fragment>
      <nav className="top-bar fixed no-bg" id="header">
        <div className="mb-0 logo-wrapper">
          {" "}
          <div className="logo-inr-wrap bottom-shadow-1 radius-bottom-16">
            {" "}
            <img
              src={tenantLogoUrl}
              alt="Logo"
              className="logo logo-wrapper-inner"
              style={{ height: "100%" }}
            />
          </div>
          <div className="top-bar-right-style-1 bottom-shadow-1 blu-bg">
            <div className="right-nav">
              <div className="user-name secondary-color right right-align">
                <span className="profile-icon secondary-color right right-align">
                  <UserProfileMenu logout = {logout} />
                </span>
              </div>  
            </div>
          </div>
        </div>
      </nav>
    </Fragment>
  );
};

Nav.propTypes = {
  auth: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  tenantLogoUrl: state.tenant.tenantInfo.tenantLogoUrl,
});

export default connect(mapStateToProps, { logout, getAllDevice })(Nav);
